import { GraphQLSchema } from 'graphql';
import { CustomDirective } from './schema/directives';
import MutationRoot from './schema/mutation';
import QueryRoot from './schema/query';
export const schema = new GraphQLSchema({
  directives: [CustomDirective],
  query: QueryRoot,
  mutation: MutationRoot
});